<template>
  <div>
    <div class="filters" style="text-align:center">
      <el-tag size='medium' align="center" effect="dark" class="mediumfee">收银台</el-tag>
    </div>
    <!-- 收费页面 -->
    <el-card>
      <div v-if="isMergePay">
        <el-form :model="diaFree" :rules="rules" ref="diaFree" :label-width="require('@/config/enum').c_ws3"
          :label-suffix="require('@/config/enum').c_colon">
          <el-row>
            <el-col>
              <el-tag size='medium' effect="dark" style="font-size: 15px;">
                {{diaFree.roomDescribe}}</el-tag>
              <el-tag style="float: right;"><span style="color:red;font-size: 15px;">提示：如存在开具电子发票企业请先进行认证，再进行收费</span>
              </el-tag>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row style="margin-left:20px">
            <el-col :span="11">
              <el-form-item label="起始时间">
                {{mergeStartText}}
              </el-form-item>
              <el-form-item :label="$t('lang.lab_feePeriod')">
                <el-link type="primary" @click="receiveShow">{{mergeRangeText}}</el-link>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_relatedTenants')">
                <el-link type="primary" @click="tenantsShow">{{$t('lang.lab_selectTenants')}}</el-link>
              </el-form-item>
              <el-form-item label="租户名称" v-if="tenantName">
                {{tenantName}}
              </el-form-item>
              <el-form-item label="款项到账">
                <el-radio-group v-model="diaFree.isBackFee">
                  <el-radio :label="0">是</el-radio>
                  <el-radio :label="1">否</el-radio>
                </el-radio-group>
                <el-tooltip class="item" effect="light" style="margin-left:20px" content="如果选【否】代表未实际缴纳费用" placement="right">
                  <el-button><i class="el-icon-warning-outline tipIcon"></i></el-button>
                </el-tooltip>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_resourRemark')" prop="remark">
                <el-input type="textarea" maxlength="200" :autosize="{minRows:4}" v-model="diaFree.remark"
                  class="inputSelect"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" align="center">
              <el-divider direction="vertical"></el-divider>
            </el-col>
            <el-col :span="11" class="payRight">
              <!-- <el-form-item :label="$t('lang.lab_totalFeePrice')" prop="totalFeePrice">
                ￥{{diaFree.totalFeePrice}}
              </el-form-item> -->
              <!-- 支付方式 -->
              <el-form-item :label="$t('lang.lab_payMethod')" prop="payMethod">
                <el-select v-model="diaFree.payMethod">
                  <el-option v-for="(item,index) in payMethodList" :key="index" :label="item.name" :value="item.id"
                    @click.native="payMethodClick(item)">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 缴费时间 -->
              <el-form-item :label="$t('lang.lab_createFeeHTime')" prop="createTime">
                <el-date-picker type="datetime" v-model="diaFree.createTime" value-format="timestamp"
                  :placeholder="$t('lang.plh.sel') + $t('lang.lab_createFeeHTime')"></el-date-picker>
              </el-form-item>
              <el-form-item label="缴费总金额">
                ￥{{diaFree.receivedAmount}}
              </el-form-item>
              <el-form-item :label="$t('lang.lab_isFeeLast')">
                <el-radio-group v-model="isFeeLast">
                  <el-radio v-for="item in isFeeManagerList" :key="item.id" :value="item.id" :label="item.id">
                    {{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_feeLast')" v-if="isFeeLast==1">
                <el-input :value="diaFree.feeLast" @input="onFeeLastInput"
                  :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_feeLast')"
                  class="inputSelect"></el-input>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_isDiscount')">
                <el-radio-group v-model="isDiscount">
                  <el-radio v-for="item in isFeeManagerList" :key="item.id" :value="item.id" :label="item.id">
                    {{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_discount')" v-if="isDiscount==1">
                <el-input @input="keyBA" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_discount')"
                  v-model="diaFree.discount" class="inputSelect"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align: center;">
            <el-button type="primary" @click="jump()">{{$t('lang.btn_backpage')}}</el-button>
            <el-button type="primary" :disabled="diaReceive.length == 0"
              @click="payMoneySave('diaFree')">{{$t('lang.lab_saveFee')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <div v-else>
        <!-- 缴费基础信息 -->
        <el-form :model="diaFree" :rules="rules" ref="diaFree" :label-width="require('@/config/enum').c_ws3"
          :label-suffix="require('@/config/enum').c_colon">
          <el-row>
            <el-col>
              <el-tag v-show='!batchPayData' size='medium' effect="dark" style="font-size: 15px;">
                {{diaFree.roomDescribe}}</el-tag>
              <el-tag style="float: right;"><span style="color:red;font-size: 15px;">提示：如存在开具电子发票企业请先进行认证，再进行收费</span>
              </el-tag>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row style="margin-left:20px">
            <el-col :span="11">
              <el-form-item label="房屋信息" prop="selectedRoom" v-if="batchPayData">
                <el-select v-model="selectedRooms" multiple collapse-tags placeholder="请选择房屋" style="width: 100%">
                  <el-option v-for="(item, index) in batchPayRooms" :key="index" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <div class="selected-rooms-tags" style="margin-top: 10px;">
                  <el-tag v-for="(item, index) in selectedRoomLabels" :key="index" size="small"
                    style="margin-right: 5px; margin-bottom: 5px;">
                    {{ item }}
                  </el-tag>
                </div>
              </el-form-item>
              <!-- 费用ID -->
              <el-form-item :label="$t('lang.lab_feeId')" v-show='!batchPayData' prop="feeId">{{diaFree.feeId}}
              </el-form-item>
              <!-- 收费项名称 -->
              <el-form-item :label="$t('lang.lab_feeName')" v-show='!batchPayData' prop="feeName">{{diaFree.feeName}}
              </el-form-item>
              <el-form-item v-if="batchPayData" :label="$t('lang.lab_feeTypeCdName')" prop="feeTypeCdName">
                <el-select v-model="feeTypeSelect">
                  <el-option v-for="(item,index) in feeTypeList" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-else :label="$t('lang.lab_feeTypeCdName')" prop="feeTypeCdName">{{diaFree.feeTypeCdName}}
              </el-form-item>
              <!-- 起始时间 -->
              <el-form-item :label="$t('lang.lab_startTime')" v-show='!batchPayData' prop="endTime">
                {{diaFree.endTime|timeYMD}}</el-form-item>
              <el-form-item :label="$t('lang.lab_AdverBeginDate')"
                v-if="diaFree.feeTypeCd=='888800010010'&& !batchPayData">
                <el-date-picker class="select" v-model="diaFree.startTimeLs" type="date" value-format="timestamp"
                  :placeholder="$t('lang.lab_AdverSelectBeginDate')"></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_AdverEndDate')"
                v-if="diaFree.feeTypeCd=='888800010010'&& !batchPayData">
                <el-date-picker class="select" v-model="diaFree.endTimeLs" type="date" value-format="timestamp"
                  :placeholder="$t('lang.lab_AdverSelsetEndDate')"></el-date-picker>
              </el-form-item>
              <!-- 收费区间 -->
              <el-form-item :label="$t('lang.lab_feePeriod')" v-if="diaFree.feeFlag == '1003006'&& !batchPayData">
                <el-link type="primary" v-if="Interval== 1" @click="receiveShow">{{minPeriod}} ~{{maxPeriod}}</el-link>
                <el-link type="primary" v-if="Interval == 2">{{'未生成应收'}}</el-link>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_housekeeper')" v-show='!batchPayData' prop="feeName">
                {{diaFree.staffName}}</el-form-item>
              <el-form-item :label="$t('lang.lab_feeBase')" prop="feeBase"
                v-if="diaFree.feeFlag == '2021101'&&diaFree.feeTypeCd!='888800010037'&& !batchPayData">
                <el-input-number :placeholder="$t('lang.lab_feeBase')" class="feeCount"
                  :label="$t('lang.lab_AdverSortText')" v-model="diaFree.feeBase" controls-position="right"
                  @change="handleChange" :min="1" :max="9999"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_invoiceType')" prop="invoiceType">
                <el-radio-group v-model="diaFree.invoiceType">
                  <el-radio :label="5">是</el-radio>
                  <el-radio :label="6">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="缴费基数" prop="feeBase" v-if="batchPayData">
                <el-input-number :placeholder="$t('lang.lab_feeBase')" :label="$t('lang.lab_AdverSortText')"
                  v-model="diaFree.feeCycle" controls-position="right" :min="1" :max="12"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_isConsume')" v-if="diaFree.feeTypeCd=='888800010037'&& !batchPayData">
                <el-radio-group v-model="diaFree.isConsume">
                  <el-radio v-for="item in isFeeManagerList" :key="item.id" :value="item.id" :label="item.id">
                    {{item.name}}</el-radio>
                </el-radio-group>
                <el-tooltip class="item" effect="light" style="margin-left:20px" content="如果选【是】右面实收费用变成扣除费用，余额扣除"
                  placement="right">
                  <el-button><i class="el-icon-warning-outline tipIcon"></i></el-button>
                </el-tooltip>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_feeGenerate')" v-if="diaFree.isConsume==1&& !batchPayData">
                <el-link type="primary">{{$t('lang.lab_generate')}}</el-link>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_feeGeduct')" v-if="diaFree.feeTypeCd=='888800010037'&& !batchPayData">
                <el-link type="primary" @click="consumeShow">{{$t('lang.lab_feeDetail')}}</el-link>
              </el-form-item>
              <!-- 关联租户 -->
              <el-form-item :label="$t('lang.lab_relatedTenants')" v-show='!batchPayData'>
                <el-link type="primary" @click="tenantsShow">{{$t('lang.lab_selectTenants')}}</el-link>
              </el-form-item>
              <el-form-item label="租户名称" v-show='!batchPayData' v-if="tenantName">
                {{tenantName}}
              </el-form-item>
              <!-- 收费备注 -->
              <el-form-item :label="$t('lang.lab_resourRemark')" prop="cycles">
                <el-input type="textarea" maxlength="200" :autosize="{minRows:4}" v-model="diaFree.remark"
                  class="inputSelect"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" align="center" :class="{'batchPayData': batchPayData }">
              <el-divider direction="vertical"></el-divider>
            </el-col>
            <el-col :span="11" class="payRight">
              <el-form-item :label="$t('lang.lab_preHouseholdArea')" prop="builtUpArea"
                v-if="diaFree.builtUpArea&& !batchPayData">
                {{diaFree.builtUpArea}}
              </el-form-item>
              <el-form-item :label="$t('lang.lab_feeArea')" prop="feeArea" v-if="!batchPayData">
                {{diaFree.feeArea}}
              </el-form-item>
              <el-form-item :label="$t('lang.lab_price')" prop="squarePrice"
                v-if="diaFree.builtUpArea&&diaFree.squarePrice>0&& !batchPayData">
                {{diaFree.squarePrice}}
              </el-form-item>
              <el-form-item :label="$t('lang.lab_additionalAmount1')" prop="additionalAmount"
                v-if="diaFree.builtUpArea&&diaFree.squarePrice>0&& !batchPayData&&!['888800010015', '888800010016'].includes(diaFree.feeTypeCd)">
                {{diaFree.additionalAmount}}</el-form-item>
              <el-form-item :label="$t('lang.lab_additionalAmount2')" prop="additionalAmount"
                v-else-if="!batchPayData&&!['888800010015', '888800010016'].includes(diaFree.feeTypeCd)">
                {{diaFree.additionalAmount}}</el-form-item>
                <!-- 应收费用  -->
              <el-form-item :label="$t('lang.lab_totalFeePrice')"
                v-show="!batchPayData&&!['888800010015', '888800010016'].includes(diaFree.feeTypeCd)"
                prop="totalFeePrice">￥{{diaFree.totalFeePrice}}
              </el-form-item>
              <!-- 支付方式 -->
              <el-form-item :label="$t('lang.lab_payMethod')" prop="payMethod">
                <el-select v-model="diaFree.payMethod">
                  <el-option v-for="(item,index) in payMethodList" :key="index" :label="item.name" :value="item.id"
                    @click.native="payMethodClick(item)">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 转换费用 -->
              <el-form-item :label="$t('lang.lab_convertProject')" v-if="depositFlag">
                <el-select v-model="diaFree.depositFeeId">
                  <el-option key :label="$t('lang.lab_feeSelectConfigName')" value=""></el-option>
                  <el-option v-for="(item,index) in depositFeeList" :key="item.feeId" :label="item.feeName"
                    :value="item.feeId" @click.native="depositFeeClick(item)">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 缴费时间 -->
              <el-form-item :label="$t('lang.lab_createFeeHTime')" prop="createTime">
                <el-date-picker type="datetime" v-model="diaFree.createTime" value-format="timestamp"
                  :placeholder="$t('lang.plh.sel') + $t('lang.lab_createFeeHTime')"></el-date-picker>
              </el-form-item>
              <!-- 调整尾差 -->
              <el-form-item :label="$t('lang.lab_isFeeLast')">
                <el-radio-group v-model="isFeeLast">
                  <el-radio v-for="item in isFeeManagerList" :key="item.id" :value="item.id" :label="item.id">
                    {{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 尾差金额 -->
              <el-form-item :label="$t('lang.lab_feeLast')" v-if="isFeeLast==1">
                <el-input :value="diaFree.feeLast" @input="onFeeLastInput"
                  :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_feeLast')"
                  class="inputSelect"></el-input>
              </el-form-item>
              <!-- 缴费折扣 -->
              <el-form-item :label="$t('lang.lab_isDiscount')">
                <el-radio-group v-model="isDiscount">
                  <el-radio v-for="item in isFeeManagerList" :key="item.id" :value="item.id" :label="item.id">
                    {{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 折扣金额  -->
              <el-form-item :label="$t('lang.lab_discount')" v-if="isDiscount==1">
                <el-input @input="keyBA" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_discount')"
                  v-model="diaFree.discount" class="inputSelect"></el-input>
              </el-form-item>
              <el-form-item :label="$t('lang.lab_receiptNumber')">
                <el-input :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_receiptNumber')"
                  v-model="diaFree.receiptNumber" class="inputSelect"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="text-align: center;">
            <el-button type="primary" @click="jump()">{{$t('lang.btn_backpage')}}</el-button>
            <el-button type="primary" :disabled="diaReceive.length == 0 && diaFree.feeFlag == '1003006'"
              @click="payMoneySave('diaFree')">{{$t('lang.lab_saveFee')}}</el-button>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 收费区间 -->

    <el-dialog :title="title" :visible.sync="isPopupPage" :close-on-click-modal="false" center top="5px !important"
      width="75%!important" @closed="gbhandleDialogClosed">
      <div>
        <el-table :data="diaReceive" ref="diaReceiveRef"
          :height="diaReceive.length > 0 ? require('@/config/enum').tableheight400 : require('@/config/enum').tableheight119"
          :row-class-name="tableRowClassName" @selection-change="handleSelectionChange"
          :cell-style="{padding: '5px 0 !important'}">
          <!-- checkbox -->
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <!-- 序号 -->
          <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
          </el-table-column>
          <el-table-column width="150px" prop="feeName" :label="$t('lang.feePay.lab_feeConfigName')"></el-table-column>
          <!-- 面积 -->
          <el-table-column width="100px" prop="houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
          <el-table-column width="100px" prop="unitName" :label="$t('lang.resourUnit')"></el-table-column>
          <el-table-column width="100px" prop="roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
          <!-- 应收金额-->
          <el-table-column width="" prop="revAmount" :label="$t('lang.lab_amountOwed')"></el-table-column>
          <el-table-column width="120px" prop="thisAmount" label="缴费金额">
            <template slot-scope="scope">
              <el-input class="thisAmountInput" v-model="scope.row.thisAmount" @input="onThisAmountInput(scope.row)"
                @blur="onThisAmountBlur(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column width="" prop="period" :label="$t('lang.lab_feePeriod')"></el-table-column>
          <!-- 计费起始时间 -->
          <el-table-column width="" prop="beginDate" :label="$t('lang.lab_startTimes')">
            <template slot-scope="scope">
              {{scope.row.beginDate|timeYMD}}
            </template>
          </el-table-column>
          <!-- 计费终止时间 -->
          <el-table-column width="" prop="minEndDate" :label="$t('lang.lab_endTimes')">
            <template slot-scope="scope">
              {{scope.row.minEndDate|timeYMD}}
            </template>
          </el-table-column>
          <el-table-column width="" prop="minStartDate" :label="$t('lang.lab_oweStartTime')">
            <template slot-scope="scope">
              {{scope.row.minStartDate|timeYMD}}
            </template>
          </el-table-column>
          <!-- 计费终止时间 -->
          <el-table-column width="" prop="minEndDate" :label="$t('lang.lab_oweEndTimes')">
            <template slot-scope="scope">
              {{scope.row.minEndDate|timeYMD}}
            </template>
          </el-table-column> <!-- v-if="isFeeManager===1" -->
          <!-- <el-table-column prop="operation" :label="$t('lang.lab_operation')" width="180px">
            <template slot-scope="scope">
              <el-button @click="delReceive(scope.row)">{{$t('lang.btn_delete')}}</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <el-row style="text-align: center;margin-top:10px">
        <el-button @click="receiveCannel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="receiveSave('diaFree')">{{$t('lang.btn_confirm')}}</el-button>
      </el-row>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="isPopupDetail" :close-on-click-modal="false" center top="5px !important"
      width="65%!important" @closed="rechargeHandleDialogClosed">
      <div>
        <el-form :inline="true">
          <!-- 选择日期 -->
          <el-form-item :label="$t('lang.lab_AdverBeginDate')" class="rechargeFrom">
            <el-date-picker class="rechargeSelect" v-model="diaFreeParam.startTime" type="date" value-format="timestamp"
              :placeholder="$t('lang.lab_AdverSelectBeginDate')"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_AdverEndDate')" class="rechargeFrom">
            <el-date-picker class="rechargeSelect" v-model="diaFreeParam.endTime" type="date" value-format="timestamp"
              :placeholder="$t('lang.lab_AdverSelsetEndDate')"></el-date-picker>
          </el-form-item>
          <el-button class="rechargeFrom" type="primary" @click="feeRechargeList()">{{$t('lang.btn_search')}}
          </el-button>
        </el-form>
        <el-table :data="diaRecharge" ref="diaReceiveRef"
          :height="diaRecharge.length > 0 ? require('@/config/enum').tableheight400 : require('@/config/enum').tableheight119"
          :row-class-name="tableRowClassName" @selection-change="handleSelectionChange"
          :cell-style="{padding: '5px 0 !important'}">
          <!-- 序号 -->
          <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="120px">
          </el-table-column>
          <el-table-column width="" prop="amount" :label="$t('lang.lab_monthlyCostAmount')"></el-table-column>
          <el-table-column width="" prop="idNo" label="扣除人"></el-table-column>
          <!-- 计费起始时间 -->
          <el-table-column width="" prop="beginDate" label="扣除时间">
            <template slot-scope="scope">
              {{scope.row.createTime|timeYMD}}
            </template>
          </el-table-column>
          <el-table-column width="" prop="remark" label="备注"></el-table-column>
          <el-table-column prop="operation" :label="$t('lang.lab_operation')" width="180px">
            <template slot-scope="scope">
              <el-button @click="delRecharge(scope.row)">{{$t('lang.btn_delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" class="fee-pagination" />
    </el-dialog>

    <el-dialog title="租户列表" :visible.sync="isTenantsPopupPage" :close-on-click-modal="false" center top="5px !important"
      width="65%!important" @closed="rechargeHandleDialogClosed">
      <div>
        <el-table :data="tableTenantData" ref="diaReceiveRef"
          :height="diaRecharge.length > 0 ? require('@/config/enum').tableheight400 : require('@/config/enum').tableheight119"
          :row-class-name="tableRowClassName" @selection-change="handleSelectionChange1"
          :cell-style="{padding: '5px 0 !important'}">
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- 序号 -->
          <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="150px">
          </el-table-column>
          <el-table-column prop="name" label="租户名称"></el-table-column>
          <el-table-column prop="createTime" label="创建时间">
            <template slot-scope="scope">{{scope.row.createTime | time}}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-row style="text-align: center;margin-top:10px">
        <el-button @click="rechargeHandleDialogClosed">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="selectTenants()">{{$t('lang.btn_confirm')}}</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  import { getPayMethodProof, isDepositPayMethod } from '@/config/payMethod'
  /**
   *@ClassName:accessControlEquipmentManagementList
   *@Description:房屋收费
   *@author:xubz
   *@Copyright:格众科技
   *@date:2020-11-26
   */
  export default {
    data() {
      return {

        rules: {
          receivedAmount: [{
            required: true,
            message: this.$i18n.t('lang.lab_receivedAmount') + '不能为空',
            trigger: 'blur',
          }, ],
          payMethod: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_payMethod'),
            trigger: 'change',
          }, ],
          createTime: [{
            required: true,
            message: '请选择缴费时间',
            trigger: 'change',
          }, ],
        },
        isFeeManagerList: this.$i18n.t('lang.AdminStrators.isFeeManagerList'),
        diaFree: {
          isBackFee:0,
          discount: '',
          discountRate: '',
          discountTime: null,
          feeLast: '',
          depositFeeId: '',
          isConsume: 0,
          invoiceType: 5,
          feeId: '',
          builtUpArea: '',
          paymentCycles: [],
          tempCycles: '',
          totalFeePrice: '',
          receivedAmount: '',
          cycles: '',
          remark: '',
          squarePrice: '',
          additionalAmount: '',
          endTime: '',
          feeFlag: '',
          feeName: '',
          feePrice: '',
          feeTypeCdName: '',
          roomName: '',
          payMethod: '',
          payMethodProof: '',
          // 后加的
          gardenId: '',
          createTime: '',
          feeBase: '1',
          startTimeLs: '',
          endTimeLs: '',
          feeTypeCd: '',
          consumeAmount: 0
        },
        diaFreeParam: {
          startTime: '',
          endTime: ''
        },
        diaRecharge: [],
        isPopupDetail: false,
        isRelationButton: this.$store.getters.isRelationButton,
        isMergePay: false,
        mergeStartText: '',
        mergeRangeText: '',
        // 本页面应用
        params: {},
        roomRow: {},
        value: 0,
        diaReceive: [],
        title: '',
        multipleSelection: [], // 多选框
        multipleSelection1: [],
        isPopupPage: false,
        isTenantsPopupPage: false,
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        periodSelection: '',
        periodPrice: '',
        minPeriod: '',
        maxPeriod: '',
        payMethodList: this.$i18n.t('lang.payMethodListBack'), // 支付方式list,
        timeDefaultShow: '',
        receiptNumber: '',
        closeMonthStart: '',
        closeMonthEnd: '',
        operPerson: '',
        Interval: 0,
        isFeeManager: 0,
        depositFlag: false,
        depositFeeList: [],
        isFeeLast: 0,
        isDiscount: 0,
        pageCount: 0,
        batchPayData: '', // 批量收费数据
        feeTypeList: [{
            id: 1,
            name: '物业费'
          },
          {
            id: 2,
            name: '车位费'
          }
        ],
        feeTypeSelect: 1,
        selectedRooms: [], // 批量收费选中的房屋
        batchPayRooms: [], // 批量收费房屋列表选项
        convertFee: '',
        tableTenantData: [],
        tenantId: '',
        tenantName: ''
      }
    },
    created() {
      const combineFlag = this.$route.query.combinedPay
      let combineList = []
      if (combineFlag) {
        try {
          const cache = window.localStorage.getItem('combinedPaySelection')
          if (cache) {
            combineList = JSON.parse(cache) || []
          }
        } catch (e) {
          console.warn('parse combinedPaySelection fail', e)
        }
      }
      if (combineFlag && combineList.length > 0) {
        this.isMergePay = true
        this.isFeeManager = this.$store.getters.isFeeManager
        this.initMergePay(combineList)
        return
      }
      console.log(this.$route.query.data)
      if (!this.$route.query.data) {
        // this.diaFree.gardenId = this.$store.getters.getGardenId
        if (this.$route.query.params['feeId'] == undefined) {
          this.params = JSON.parse(window.localStorage.getItem('paramsls'))
          this.roomRow = JSON.parse(window.localStorage.getItem('rowls'))
        } else {
          window.localStorage.removeItem('paramsls')
          window.localStorage.removeItem('rowls')
          window.localStorage.setItem('paramsls', JSON.stringify(this.$route.query.params))
          window.localStorage.setItem('rowls', JSON.stringify(this.$route.query.row))
          this.params = this.$route.query.params
          this.roomRow = this.$route.query.row
        }
        debugger
        this.isFeeManager = this.$store.getters.isFeeManager
        this.payMoney()
        this.feeReceiveList(this.params.feeId)
        this.feeCloseMonth()
      } else {
        this.batchPayData = this.$route.query.data
        // 处理批量收费数据,生成房屋选项
        this.batchPayRooms = this.batchPayData.map(item => {
          return {
            label: `${item.houseName}-${item.unitName}-${item.roomName}`,
            value: item.roomId
          }
        })
        // 默认全选
        this.selectedRooms = this.batchPayRooms.map(item => item.value)
      }

    },
    watch: {
      diaFree: {
        handler(newVal, oldVal) {
          // form数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule == this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true,
      },
    },
    computed: {
      selectedRoomLabels() {
        return this.batchPayRooms
          .filter(item => this.selectedRooms.includes(item.value))
          .map(item => item.label)
      }
    },
    methods: {
      initMergePay(list) {
        const sel = (list || []).map((item, index) => {
          return Object.assign({}, item, {
            row_index: index,
            gardenId: item.gardenId || item.garden_id || '',
            houseId: item.houseId || item.house_id || '',
            unitId: item.unitId || item.unit_id || '',
            roomId: item.roomId || item.room_id || '',
            thisAmount: item.thisAmount || item.revAmount || item.receiveAmount || 0,
            builtUpAre: item.builtUpAre || item.buildArea || item.builtUpArea || '',
            feeArea: item.feeArea || item.buildArea || '',
            price: item.price || item.squarePrice || item.square_price|| item.feeName|| item.houseName|| item.unitName|| item.roomName|| '',
          })
        })
        this.diaReceive = sel
        this.multipleSelection = [...sel]
        const startVals = sel
          .map(i => Number(i.minStartDate || i.beginDate || i.startTime || 0))
          .filter(n => n > 0)
        const minStart = startVals.length ? Math.min(...startVals) : ''
        const maxStart = startVals.length ? Math.max(...startVals) : ''
        this.mergeStartText = this.formatDateText(minStart)
        this.mergeRangeText = maxStart ? `${this.mergeStartText} ~ ${this.formatDateText(maxStart)}` : this.mergeStartText
        this.minPeriod = this.mergeStartText
        this.maxPeriod = this.formatDateText(maxStart)
        const rooms = sel
          .map(item => [item.houseName, item.unitName, item.roomName].filter(Boolean).join('-'))
          .filter(Boolean)
          .join(',')
        this.diaFree.roomDescribe = rooms
        this.diaFree.gardenId = sel[0] ? (sel[0].gardenId || sel[0].garden_id || '') : ''
        this.diaFree.houseId = sel[0] ? (sel[0].houseId || sel[0].house_id || '') : ''
        this.diaFree.unitId = sel[0] ? (sel[0].unitId || sel[0].unit_id || '') : ''
        this.diaFree.roomId = sel[0] ? (sel[0].roomId || sel[0].room_id || '') : ''
        this.diaFree.feeFlag = sel[0] ? (sel[0].feeFlag || '') : ''
        this.diaFree.feeTypeCd = sel[0] ? (sel[0].feeTypeCd || '') : ''
        this.diaFree.feeTypeCdName = sel[0] ? (sel[0].feeTypeCdName || '') : ''
        this.diaFree.feeName = sel[0] ? (sel[0].feeName || '') : ''
        this.diaFree.feeId = sel[0] ? (sel[0].feeId || '') : ''
        this.diaFree.totalFeePrice = this.calcTotalFee(sel)
        this.diaFree.receivedAmount = this.diaFree.totalFeePrice
        this.diaFree.payMethod = ''
        this.diaFree.createTime = ''
        this.diaFree.remark = ''
      },
      formatDateText(ts) {
        if (!ts) {
          return ''
        }
        try {
          if (this.$options.filters && this.$options.filters.timeYMD) {
            return this.$options.filters.timeYMD(ts)
          }
          const d = new Date(ts)
          if (isNaN(d.getTime())) return ''
          const y = d.getFullYear()
          const m = (d.getMonth() + 1).toString().padStart(2, '0')
          const day = d.getDate().toString().padStart(2, '0')
          return `${y}-${m}-${day}`
        } catch (e) {
          return ''
        }
      },
      calcTotalFee(list) {
        const sum = (list || []).reduce((prev, item) => {
          const val = item.thisAmount || item.revAmount || item.receiveAmount || 0
          const num = parseFloat(val || 0)
          return prev + (isNaN(num) ? 0 : num)
        }, 0)
        return sum ? sum.toFixed(2) : '0.00'
      },
      depositFeeClick(val) {
        this.diaFree.receivedAmount = val.additionalAmount
        this.convertFee = this.diaFree.receivedAmount
        console.log(this.convertFee)
      },
      payMethodClick(val) {
        this.diaFree.payMethodProof = getPayMethodProof(val.id)
        this.diaFree.depositFeeId = ""
        if (isDepositPayMethod(val.id)) {
          if (this.diaFree.feeFlag == "2006012") {
            this.$message.error('收费方式选择错误')
            return
          }
          this.depositFlag = true
          this.getDepositFeeList()
        } else {
          this.depositFlag = false
        }
        console.log(this.roomRow)
      },
      getDepositFeeList() {
        let loading = this.$loading()
        let params = {
          gardenId: this.roomRow.gardenId,
          payerObjId: this.roomRow.roomId,
          feeFlag: "2006012",
          state: "2020001",
          isConvertFee: 0,
          pageNo: 1,
          pageSize: 30
        }
        this.$get(`/feePayInfo/`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.depositFeeList = res.list

            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.feeRechargeList()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.feeRechargeList()
      },
      delRecharge(row) {
        this.$confirm(this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
            let loading = this.$loading()
            this.$postJson(`/delRecharge/`, row).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_del_success'))
                    this.feeRechargeList()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              // })
              .catch(() => {
                loading.close()
                this.$message({
                  type: 'info',
                  message: this.$i18n.t('lang.lab_del_can')
                })
              })
          })
      },
      rechargeHandleDialogClosed() {
        this.isPopupPage = false
      },

      consumeShow() {
        this.isPopupDetail = true
        this.title = '扣除明细'
        this.feeRechargeList()
      },
      feeRechargeList() {
        let loading = this.$loading()
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          feeId: this.params.feeId,
          startTs: this.diaFreeParam.startTime,
          endTs: this.diaFreeParam.endTime,
        }
        this.$get(`/feeRechargeList`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.diaRecharge = res.list
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      delReceive(row) {
        let loading = this.$loading()
        this.$postJson(`/delFeeReceive/`, row).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_del_success'))
                this.feeReceiveListShow(this.params.feeId)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
          // })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })

      },
      feeReceiveListShow(feeId) {
        let loading = this.$loading()
        this.$get(`/feeReceiveList?feeId=${feeId}`).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              debugger
              res.list.map((item, index) => {
                Object.assign(item, {
                  builtUpAre: this.params.builtUpAre
                }, {
                  price: this.params.price
                }, {
                  feeArea: this.params.feeArea
                }, {
                  thisAmount: item.revAmount
                })
              })
              this.diaReceive = res.list
              if (res.list.length > 0) {
                this.minPeriod = res.list[0].minPeriod
                this.maxPeriod = res.list[0].maxPeriod
                this.Interval = 1
              } else {
                this.Interval = 2
              }
              this.isDisabled = false
              this.$nextTick(() => {
                for (let i = 0; i < this.diaReceive.length; i++) {
                  this.$refs.diaReceiveRef.toggleRowSelection(this.diaReceive[i], true)
                }
              })
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      handleChange(value) {
        console.log(value)
        if (value == '') {
          return
        }
        this.diaFree.receivedAmount = parseFloat((this.diaFree.totalFeePrice * value).toFixed(2))
      },
      feeCloseMonth() {
        let loading = this.$loading()
        this.$get(`/getCloseMonthEntity`).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0 && res.feeCloseMonth != null) {
              this.closeMonthStart = res.feeCloseMonth.startTime
              this.closeMonthEnd = res.feeCloseMonth.endTime
              console.log(res)
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      keyBA() {
        // 仅保留数字和"."
        if (this.diaFree.feeFlag == '1003006') {
          this.diaFree.receivedAmount = this.diaFree.receivedAmount.replace(/[^\d.]/g, '')
        }
        // 首位是0的话去掉
        if (this.diaFree.receivedAmount.indexOf('.') < 0 && this.diaFree.receivedAmount != '') {
          this.fdiaFree.receivedAmount = parseFloat(this.diaFree.receivedAmount)
        }
      },
      // 尾差金额输入：允许整数和小数，且小于等于5
      onFeeLastInput(value) {
        let raw = (value !== undefined && value !== null ? value : this.diaFree.feeLast || '').toString()
        raw = raw.replace(/[^\d.]/g, '')
        const parts = raw.split('.')
        let val = parts.shift() || ''
        if (parts.length > 0) {
          val += '.' + parts.join('').substring(0, 2) // 小数位最多2位
        }
        // 保留输入中状态，如 "5." 以便继续输入 "5.2"
        if (val.endsWith('.')) {
          this.$set(this.diaFree, 'feeLast', val)
          return
        }
        const num = parseFloat(val)
        if (isNaN(num)) {
          this.$set(this.diaFree, 'feeLast', val)
          return
        }
        if (num > 5) {
          this.$message.error('尾差金额不能大于5')
          this.$set(this.diaFree, 'feeLast', '5')
          return
        }
        this.$set(this.diaFree, 'feeLast', val)
      },
      // 根据折扣率计算折扣金额：仅对选中的明细计算 discountDetail；diaFree.discount = 选中行 discountDetail 之和
      updateDiscountAmount() {
        const clearAllDetail = () => {
          if (Array.isArray(this.diaReceive)) {
            this.diaReceive.forEach(item => {
              this.$set(item, 'discountDetail', 0)
            })
          }
        }
        if (this.isDiscount != 1) {
          this.diaFree.discount = ''
          clearAllDetail()
          return
        }
        const rateRaw = this.diaFree.discountRate
        if (
          rateRaw == null ||
          rateRaw === '' ||
          String(rateRaw).trim() === ''
        ) {
          this.diaFree.discount = '0.00'
          clearAllDetail()
          return
        }
        let rate = parseFloat(rateRaw)
        if (isNaN(rate) || rate < 0) {
          rate = 0
        }
        if (rate > 1) {
          rate = 1
        }

        // 未选中的行 discountDetail 置 0
        clearAllDetail()

        const selected = Array.isArray(this.multipleSelection) ? this.multipleSelection : []
        let sum = 0
        selected.forEach(item => {
          const amt = parseFloat(item.thisAmount || 0)
          const detail = isNaN(amt) ? 0 : amt * (1 - rate)
          const fixed = isNaN(detail) ? 0 : parseFloat(detail.toFixed(2))
          this.$set(item, 'discountDetail', fixed)
          sum += fixed
        })
        this.diaFree.discount = sum.toFixed(2)
      },
      gbhandleDialogClosed() {
        this.receiveSave()
      },
      receiveCannel() {
        this.receiveSave()
        this.isPopupPage = false
      },
      receiveSave() {
        console.log(this.multipleSelection)
        if (this.multipleSelection.length == 0 && this.diaFree.feeFlag == '1003006') {
          this.$message.error('请选择收费区间')
          return
        }

        if (this.multipleSelection.length != null && this.multipleSelection.length > 0) {
          // 计算缴费总金额
          let periodPrice = this.multipleSelection.reduce(function (prev, item) {
            return (prev + Number(item.thisAmount || 0))
          }, 0)
          this.minPeriod = this.multipleSelection[0].period
          this.maxPeriod = this.multipleSelection[this.multipleSelection.length - 1].period
          this.diaFree.receivedAmount = periodPrice.toFixed(2)
          this.diaFree.totalFeePrice = periodPrice.toFixed(2)
          this.updateDiscountAmount()
          this.isPopupPage = false
        }
      },
      onThisAmountInput(row) {
        // 只允许输入数字和小数点
        const raw = (row.thisAmount || '').toString()
        const cleaned = raw.replace(/[^\d.]/g, '')
        const parts = cleaned.split('.')
        let value = parts.shift() || ''
        if (parts.length > 0) {
          value += '.' + parts.join('')
        }
        row.thisAmount = value
      },
      onThisAmountBlur(row) {
        const owe = Number(row.revAmount || 0)
        let amt = Number(row.thisAmount || 0)
        if (isNaN(amt) || amt <= 0) {
          row.thisAmount = ''
          return
        }
        if (amt > owe) {
          amt = owe
        }
        row.thisAmount = parseFloat(amt).toFixed(2)
      },
      // 列表隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        row.row_index = rowIndex
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        if (val) {
          // 保证选择连续：仅在新增选中时自动补选上方行；用户手动取消时不强制选回
          const prevLen = Array.isArray(this.multipleSelection) ? this.multipleSelection.length : 0
          const isAdding = val.length > prevLen
          if (isAdding) {
            const selectedIndexSet = new Set(val.map(item => item.row_index))
            if (val.length > 0) {
              const maxIndex = Math.max(...selectedIndexSet)
              for (let i = 0; i <= maxIndex; i++) {
                const row = this.diaReceive[i]
                if (row && !selectedIndexSet.has(row.row_index)) {
                  this.$refs.diaReceiveRef.toggleRowSelection(row, true)
                }
              }
            }
          }
          this.multipleSelection = val
        }
      },
      handleSelectionChange1(val) {
        if (val) {
          this.multipleSelection1 = val
        }
      },
      tenantsShow() {
        this.selectTenantList()
        this.isTenantsPopupPage = true
      },

      selectTenantList() {
        const ownerIds = []
        const seen = new Set()
        if (this.isMergePay && Array.isArray(this.diaReceive) && this.diaReceive.length > 0) {
          this.diaReceive.forEach(row => {
            const oid = row.ownerId
            if (oid != null && oid !== '' && !seen.has(oid)) {
              seen.add(oid)
              ownerIds.push(oid)
            }
          })
        } else if (this.roomRow && this.roomRow.ownerId != null && this.roomRow.ownerId !== '') {
          ownerIds.push(this.roomRow.ownerId)
        }
        if (!ownerIds.length) {
          this.$message.warning('未获取到业主ID，无法查询关联租户')
          this.tableTenantData = []
          return
        }
        let loading = this.$loading()
        const params =
          ownerIds.length > 1
            ? { ownerIds: ownerIds.join(',') }
            : { ownerId: ownerIds[0] }
        this.$get('/getTenantList', params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableTenantData = res.list || []
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      tenantsDialogClosed() {
        this.isTenantsPopupPage = false
      },
      selectTenants() {
        console.log(this.multipleSelection1)
        if (this.multipleSelection1.length == 0) {
          this.$message.error('请选择租户')
          return
        }
        if (this.multipleSelection1.length > 1) {
          this.$message.error('请选择一个租户')
          return
        }
        this.tenantId = this.multipleSelection1[0].id
        this.tenantName = this.multipleSelection1[0].name
        this.isTenantsPopupPage = false
      },
      receiveShow() {
        this.isPopupPage = true
        this.title = '应收明细'
        this.$nextTick(() => {
          if (this.$refs.diaReceiveRef && this.diaReceive.length > 0) {
            // 先清空所有选择
            this.$refs.diaReceiveRef.clearSelection()
            // 全选所有数据
            for (let i = 0; i < this.diaReceive.length; i++) {
              this.$refs.diaReceiveRef.toggleRowSelection(this.diaReceive[i], true)
            }
            // 更新 multipleSelection 为全选的数据
            this.multipleSelection = [...this.diaReceive]
          }
        })
      },
      feeReceiveList(feeId) {
        let loading = this.$loading()
        this.$get(`/feeReceiveList?feeId=${feeId}`).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              res.list.map((item, index) => {
                Object.assign(item, {
                  builtUpAre: this.params.builtUpAre
                }, {
                  price: this.params.price
                }, {
                  feeArea: this.params.feeArea
                }, {
                  thisAmount: item.revAmount
                })
              })
              this.diaReceive = res.list
              if (res.list.length > 0) {
                this.minPeriod = res.list[0].minPeriod
                this.maxPeriod = res.list[0].maxPeriod
                this.Interval = 1
              } else {
                this.Interval = 2
              }
              this.isDisabled = false
              console.log(this.diaReceive)
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      jump() {
        // if (!this.batchPayData) {
        //   this.$router.push({
        //     name: 'feeRoomList',
        //     query: {
        //       row: this.roomRow
        //     }
        //   })
        // } else {
          this.$router.push({ name: 'feeReceiveQuery' })
          // this.$router.push({
          //   name: 'feePayList',
          // })
        // }

      },
      payMoneySave(diaForm) {
        this.$confirm(this.$i18n.t('lang.lab_isSaveFee'),
          this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
          if (this.isMergePay) {
            this.handleMergePaySave()
            return
          }
          if (this.isDiscount === 1) {
            const discountTimeYear = this.diaFree.discountTime != null && this.diaFree.discountTime !== ''
              ? (typeof this.diaFree.discountTime === 'number'
                  ? this.diaFree.discountTime
                  : parseInt(String(this.diaFree.discountTime), 10))
              : null
            if (discountTimeYear != null && !isNaN(discountTimeYear)) {
              const selected = this.multipleSelection || []
              const hasNonDiscount = selected.some(item => {
                const period = (item.period || '').toString().trim()
                if (!period) return false
                const match = period.match(/^(\d{4})/)
                const year = match ? match[1] : ''
                return year !== String(discountTimeYear)
              })
              if (hasNonDiscount) {
                this.$message.error('存在非打折账单')
                return
              }
            }
          }
          if (this.diaFree.tempCycles != '' && this.diaFree.tempCycles != '-102' && this.diaFree.tempCycles !=
            undefined) {
            this.diaFree.cycles = this.diaFree.tempCycles
          }
          if (this.diaFree.feeFlag == '2006012') {
            this.diaFree.cycles = '1'
          }
          if (this.diaFree.cycles == '' || this.diaFree.tempCycles == undefined) {
            this.diaFree.cycles = '-101'
          }
          if (this.multipleSelection.length == 0 && this.diaFree.feeFlag == '1003006') {
            this.$message.error('请选择收费区间')
            return
          }
          if (this.diaFree.payMethod == '' || this.diaFree.payMethod == undefined) {
            this.$message.error('请选择收费方式')
            return
          }
          if (this.diaFree.createTime == '' || this.diaFree.createTime == undefined) {
            this.$message.error('请选择缴费时间')
            return
          } else if (this.closeMonthStart <= this.diaFree.createTime && this.diaFree.createTime < this
            .closeMonthEnd) {
            this.$message.error('该时间已封账无法缴费')
            return
          }
          if ((this.diaFree.receivedAmount == '' || this.diaFree.receivedAmount == undefined)) {
            this.$message.error('请输入实收费用')
            return
          }
          if (this.diaFree.feeFlag == "2006012" && isDepositPayMethod(this.diaFree.payMethod)) {
            this.$message.error('收费方式选择错误')
            return
          }
          if (isDepositPayMethod(this.diaFree.payMethod) && parseFloat(this.diaFree.receivedAmount) != parseFloat(this
            .convertFee)) {
            this.$message.error('实收费用和转换费用不等')
            return
          }

          // if (this.diaFree.receiptNumber == '' || this.diaFree.receiptNumber == undefined) {
          //     this.$message.error('请输入收据单号')
          //     return
          // }
          if (this.diaFree.feeTypeCd == '888800010010' && this.diaFree.startTimeLs == undefined) {
            this.$message.error('请选择起始时间')
            return
          }
          if (this.diaFree.feeTypeCd == '888800010010' && this.diaFree.endTimeLs == undefined) {
            this.$message.error('请选择结束时间')
            return
          }
          if (this.diaFree.feeTypeCd == '888800010010' && this.diaFree.startTimeLs < this.diaFree.endTime) {
            this.$message.error('开始时间不能小于起始时间')
            return
          }
          if (this.diaFree.feeTypeCd == '888800010010' && this.diaFree.endTimeLs < this.diaFree.startTimeLs) {
            this.$message.error('结束时间不能小于开始时间')
            return
          }
          if (this.diaFree.feeTypeCd == '888800010037' && this.diaFree.isConsume == undefined) {
            this.$message.error('请选择是否扣除费用')
            return
          }
          let longinId = ''
          let isTenant = 0
          let payPersonId = ''
          if (this.$store.getters.userData.id) {
            longinId = this.$store.getters.userData.id
          }
          if (this.tenantId != '' && this.tenantId != undefined) {
            payPersonId = this.tenantId
            isTenant = 1
          } else {
            payPersonId = this.roomRow.rId
            isTenant = 0
          }
          let params = {
            additionalAmount: this.diaFree.additionalAmount,
            builtUpArea: this.diaFree.builtUpArea,
            gardenId: this.diaFree.gardenId,
            houseId: this.diaFree.houseId,
            unitId: this.diaFree.unitId,
            roomId: this.diaFree.roomId,
            cycles: this.diaFree.cycles,
            endTime: this.diaFree.endTime,
            feeFlag: this.diaFree.feeFlag,
            feeId: this.diaFree.feeId,
            feeName: this.diaFree.feeName,
            feePrice: this.diaFree.feePrice,
            feeTypeCd: this.diaFree.feeTypeCd,
            feeTypeCdName: this.diaFree.feeTypeCdName,
            paymentCycles: this.diaFree.paymentCycles,
            receivedAmount: this.diaFree.receivedAmount,
            remark: this.diaFree.remark,
            roomName: this.diaFree.roomName,
            squarePrice: this.diaFree.squarePrice,
            tempCycles: this.diaFree.tempCycles,
            totalFeePrice: this.diaFree.totalFeePrice,
            receiptVo: this.multipleSelection.map(item => ({
              ...item,
              thisAmount: item.thisAmount,
              discountDetail: item.discountDetail || 0
            })),
            payMethod: this.diaFree.payMethod,
            pay_method_proof: this.diaFree.payMethodProof || getPayMethodProof(this.diaFree.payMethod),
            createTime: this.diaFree.createTime,
            operPerson: longinId,
            receiptNumber: this.diaFree.receiptNumber,
            invoiceType: this.diaFree.invoiceType,
            startTimeLs: this.diaFree.startTimeLs,
            endTimeLs: this.diaFree.endTimeLs,
            isConsume: this.diaFree.isConsume,
            depositFeeId: this.diaFree.depositFeeId,
            isFeeLast: this.isFeeLast,
            feeLast: this.diaFree.feeLast,
            isTenant: isTenant,
            payPersonId: payPersonId,
            isBackFee: this.diaFree.isBackFee
          }
          console.log(params)
          let loading = this.$loading()
          this.$postJson(`/payFeeDetail`, params).then(
            (res) => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.jump()
              } else {
                this.$message.error(error)
              }
            },
            (error) => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
      },
      handleMergePaySave() {
        if (this.diaReceive.length === 0) {
          this.$message.error('请选择收费区间')
          return
        }
        if (this.isDiscount === 1) {
          const discountTimeYear = this.diaFree.discountTime != null && this.diaFree.discountTime !== ''
            ? (typeof this.diaFree.discountTime === 'number'
                ? this.diaFree.discountTime
                : parseInt(String(this.diaFree.discountTime), 10))
            : null
          if (discountTimeYear != null && !isNaN(discountTimeYear)) {
            const hasNonDiscount = this.diaReceive.some(item => {
              const period = (item.period || '').toString().trim()
              if (!period) return false
              const match = period.match(/^(\d{4})/)
              const year = match ? match[1] : ''
              return year !== String(discountTimeYear)
            })
            if (hasNonDiscount) {
              this.$message.error('存在非打折账单')
              return
            }
          }
        }
        if (this.diaFree.payMethod == '' || this.diaFree.payMethod == undefined) {
          this.$message.error('请选择收费方式')
          return
        }
        if (this.diaFree.createTime == '' || this.diaFree.createTime == undefined) {
          this.$message.error('请选择缴费时间')
          return
        }
        const longinId = this.$store.getters.userData.id || ''
        const isTenant = this.tenantId ? 1 : 0
        
        const grouped = this.diaReceive.reduce((acc, item) => {
          const key = item.feeId || 'default'
          if (!acc[key]) {
            acc[key] = []
          }
          acc[key].push(item)
          return acc
        }, {})
        const loading = this.$loading()
        const tasks = Object.keys(grouped).map(feeId => {
          const items = grouped[feeId]
          const first = items[0] || {}
          const receivedAmount = this.calcTotalFee(items)
          const receiptVo = items.map(it => ({
            minStartDate: it.minStartDate || '',
            period: it.period || '',
            minEndDate: it.minEndDate || '',
            rId: it.rId || '',
            maxPeriod: it.maxPeriod || '',
            feeId: it.feeId || feeId,
            houseId: it.houseId || it.house_id || '',
            unitId: it.unitId || it.unit_id || '',
            roomId: it.roomId || it.room_id || '',
            beginDate: it.beginDate || it.minStartDate || '',
            receiveAmount: it.receiveAmount || '',
            revAmount: it.revAmount || '',
            thisAmount: it.thisAmount || '',
            discountDetail: it.discountDetail || 0,
            createTime: it.createTime || this.diaFree.createTime || '',
            state: it.state || '0',
            paidAmount: it.paidAmount || '',
            gardenId: it.gardenId || '',
            builtUpAre: it.builtUpAre || '',
            price: it.price || '',
            feeArea: it.feeArea || '',
            row_index: it.row_index || 0
          }))
          let payPersonId = '';
          if (this.tenantId) {
            payPersonId = this.tenantId
          } else {
            payPersonId = first.childId
          }
          const params = {
            additionalAmount: first.additionalAmount || '0.00',
            builtUpArea: first.builtUpAre || first.buildArea || first.builtUpArea || '',
            gardenId: first.gardenId || first.garden_id || '',
            houseId: first.houseId || first.house_id || '',
            unitId: first.unitId || first.unit_id || '',
            roomId: first.roomId || first.room_id || '',
            cycles: '-101',
            endTime: first.minEndDate || first.endTime || '',
            feeFlag: first.feeFlag || '',
            feeId: feeId,
            feeName: first.feeName || '',
            feePrice: first.feePrice || first.price || '',
            feeTypeCd: first.feeTypeCd || '',
            feeTypeCdName: first.feeTypeCdName || '',
            receivedAmount: receivedAmount,
            remark: this.diaFree.remark,
            roomName: first.roomName || '',
            squarePrice: first.price || first.squarePrice || '',
            totalFeePrice: receivedAmount,
            receiptVo: receiptVo,
            payMethod: this.diaFree.payMethod || '',
            pay_method_proof: this.diaFree.payMethodProof || getPayMethodProof(this.diaFree.payMethod),
            createTime: this.diaFree.createTime || '',
            operPerson: longinId,
            depositFeeId: this.diaFree.depositFeeId || '',
            isFeeLast: this.isFeeLast,
            isTenant: isTenant,
            payPersonId: payPersonId,
            feeLast: this.diaFree.feeLast || '',
            isBackFee: this.diaFree.isBackFee
          }
          return this.$postJson(`/payFeeDetail`, params)
        })
        Promise.all(tasks).then(() => {
          loading.close()
          this.$message.success(this.$i18n.t('lang.lab_save_success'))
          this.$router.push({ name: 'feeActualQuery' })
        }).catch((error) => {
          loading.close()
          this.$message.error(error || '保存失败')
        })
      },
      // 收费  许
      payMoney() {
        let loading = this.$loading()
        this.$get(`/feePayInfo/`, this.params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.diaFree = res.list[0]
              let g, feemu
              if (res.list[0].additionalAmount > 0) {
                g = parseFloat(res.list[0].additionalAmount).toFixed(2)
                feemu = (parseFloat((res.list[0].builtUpArea * res.list[0].squarePrice).toFixed(2)) + parseFloat(g))
                  .toFixed(2)
              } else {
                feemu = parseFloat((res.list[0].builtUpArea * res.list[0].squarePrice).toFixed(2))
              }


              if (this.diaFree.computingFormula == '2002' && this.diaFree.feeFlag == '2006012') {
                this.diaFree.totalFeePrice = res.list[0].revAmount
                this.$set(this.diaFree, 'receivedAmount', res.list[0].revAmount)
              } else if (this.diaFree.computingFormula == '2002' && this.diaFree.feeFlag == '2021101') {
                this.diaFree.totalFeePrice = feemu
                this.$set(this.diaFree, 'receivedAmount', feemu)
              } else {
                this.diaFree.totalFeePrice = feemu
                this.$set(this.diaFree, 'receivedAmount')
              }
              this.$set(this.diaFree, 'feeBase', 1)
              this.$set(this.diaFree, 'invoiceType', 5)
              this.$set(this.diaFree, 'consumeAmount', 0)
              this.$set(this.diaFree, 'depositFeeId', "")
              this.$set(this.diaFree, 'feeArea', this.params.feeArea)
              this.$set(this.diaFree, 'feeLast', this.diaFree.feeLast || '')
              this.$set(this.diaFree, 'isBackFee', 0)
              this.pageCount = res.pageCount
              this.isDisabled = false
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      changeMonth(cycles) {
        if (cycles == '-102') {
          this.diaFree.totalFeePrice = 0.00
          this.$set(this.diaFree, 'receivedAmount', '')
          this.$set(this.diaFree, 'cycles', '')
          return
        }
        let newCycles = cycles

        if (cycles == '') {
          newCycles = this.diaFree.paymentCycles[0]
        }
        this.diaFree.totalFeePrice = Math.floor(parseFloat(newCycles) * parseFloat(this.diaFree.feePrice) * 100) / 100
        this.diaFree.receivedAmount = this.diaFree.totalFeePrice
      },
      changeCycle(cycles) {
        let newCycle = cycles
        if (cycles == '') {
          return
        }
        this.diaFree.totalFeePrice = Math.floor(parseFloat(newCycle) * parseFloat(this.diaFree.feePrice) * 100) / 100
        this.diaFree.receivedAmount = this.diaFree.totalFeePrice
      },
    },

  }
</script>

<style lang="scss" scoped>
  .nextPMTime label {
    width: 150px !important;
  }

  .tagStyle {
    width: 100px;
    margin-top: 3px;
  }

  .el-tag.el-tag--info {
    background-color: #cdcdd0 !important;
    border-color: #fcf9f9 !important;
    color: #37383a !important;
  }

  .el-dialog__header {
    border-bottom: none !important;
  }

  .el-dialog .el-form {
    padding: 0px 10px 0 0px !important;
  }

  .el-divider--horizontal {
    margin: 15px 0 !important;
  }

  .el-divider--vertical {
    height: 25em !important;
    margin: 20px 15px !important;
  }

  .inputSelect {
    width: 50% !important;
  }

  .inputSelect>.el-input {
    width: 100% !important;
  }

  .mediumfee {
    height: 32px !important;
    line-height: 32px !important;
    font-size: 25px !important;
    width: 150px !important;
  }

  .diaReceiveTable {
    height: 300px;
  }

  .el-select,
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 50% !important;
  }

  .el-input--suffix {
    width: 100% !important;
  }

  .el-date-editor .el-input__inner {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  .el-date-editor .el-icon-time {
    display: none;
  }

  .rechargeSelect.el-input,
  .rechargeSelect.el-input__inner {
    width: 100% !important;
  }

  .rechargeFrom {
    margin-left: 10px;
  }

  .batchPayData .el-divider--vertical {
    height: 25em !important;
  }

  .payRight::v-deep .el-form-item__label {
    text-align: left !important;
  }

  .thisAmountInput {
    width: 90px;
  }

  .thisAmountInput ::v-deep .el-input__inner {
    text-align: center !important;
  }
</style>